import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-multimedia-manager-dialog-item',
  templateUrl: './multimedia-manager-dialog-item.component.html',
  styleUrls: ['./multimedia-manager-dialog-item.component.scss']
})
export class MultimediaManagerDialogItemComponent implements OnInit {

  @Input() item;
  @Input() currentFolder;
  @Input() currentFatherFolder;

  constructor() { }

  ngOnInit() {
  }
}
